import { render, staticRenderFns } from "./Nominee.vue?vue&type=template&id=6f16d41a"
import script from "./Nominee.vue?vue&type=script&lang=js"
export * from "./Nominee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports